<template>
    <div class="politique-confidentialité-contaienr pt-40 px-3 px-lg-0">
        <h1 class="title text-center pb-3 fw-medium text-gray-900">Politique de Confidentialité</h1>
        <p class="text-center text-gray-500 fw-medium mb-xs-32 mb-xl-64">Dernière mise à jour : 7 Décembre 2023</p>
        <div class="pe-xs-0 pe-xl-80 pb-80">
            <p class="text-gray-500 pt-xs-32 pt-xl-64 pb-xs-32 pb-xl-80">Bienvenue sur Topauto. En utilisant notre plateforme, vous acceptez les conditions énoncées ci-dessous. Veuillez lire attentivement ces Conditions d’Utilisation avant de naviguer, vendre ou acheter sur Topauto.</p>
            <div v-for="(section, index) in content" :key="index">
                <h2 class="SectionTitle fs-4 text-gray-900 fw-bold">{{ section.title }}</h2>
                <div class="SectionBody pt-3 pb-40 text-gray-600" v-if="typeof section.body === 'string'">
                  <p >{{ section.body }}</p>
                </div>
                
                <div class="SubSection " v-else>
                  <div class="pt-3" v-for="(subSection, subIndex) in section.body" :key="subIndex">
                    <h6 class="fw-bold pb-2">{{ subSection.subTitle }}</h6>
                    <p class="SubSectionTitle-body pb-3 text-gray-600">{{ subSection.body }}</p>
                  </div>
                </div>
                <ul v-if="section.items" class="ItemsList pb-40 pt-3 text-gray-600">
                    <li v-for="(item, itemIndex) in section.items" :key="itemIndex" class="ItemsListItem">{{ item }}</li>
                  </ul>
            </div>
            </div>
    </div>
</template>

<script setup lang="ts">
const runTimeConfig = useRuntimeConfig();
const route = useRoute();

definePageMeta({
  layout: "terms-layout",
});
const content = ref([
    {

        title: '1. Informations Collectées',
        body:[
            {subTitle: "1.1 Informations Personnelles", body:"Lorsque vous utilisez Topauto, nous pouvons collecter des informations personnelles, telles que votre nom, adresse e-mail, numéro de téléphone, et autres informations que vous choisissez de nous fournir."},
            {subTitle: "1.2 Informations Non Personnelles", body:"Nous pouvons également collecter des informations non personnelles, telles que des données démographiques, des préférences de navigation, et des statistiques d’utilisation du site, de manière agrégée et anonyme."},            
        ]
    },
    {
        title:'2.Utilisation du Service',
        items:['Faciliter l’utilisation de Topauto','Personnaliser votre expérience sur la plateforme','Traiter vos transactions et demandes','Améliorer nos produits et services']
    },
    {
        title:"3. Divulgation des Informations",
        body:"Nous ne vendons, n’échangeons ni ne louons vos informations personnelles à des tiers sans votre consentement, sauf dans les cas expressément décrits dans cette Politique de Confidentialité ou lorsque requis par la loi."
    },
    {
        title:"4. Sécurité des Informations",
        body:"Topauto se réserve le droit de modifier ces Conditions d’Utilisation à tout moment. Les modifications seront publiées sur cette page avec la date de la dernière mise à jour. Il est de votre responsabilité de vérifier régulièrement les mises à jour."
    },
    {
        title:"5. Cookies et Technologies Similaires",
        body:"Topauto utilise des cookies et des technologies similaires pour améliorer votre expérience utilisateur. Vous pouvez ajuster vos préférences de cookies dans les paramètres de votre navigateur."
    },
    {
        title:"6. Modifications de la Politique de Confidentialité",
        body:"Nous nous réservons le droit de mettre à jour cette Politique de Confidentialité à tout moment. Les modifications seront publiées sur cette page avec la date de la dernière mise à jour."
    },
    {
        title:"7. Consentement",
        body:"En utilisant Topauto, vous consentez à la collecte et à l’utilisation de vos informations conformément à cette Politique de Confidentialité."
    },
    {
        title:"8. Contactez-nous",
        body:"Si vous avez des questions concernant cette Politique de Confidentialité, veuillez nous contacter à contact@topauto.tn."
    }
]);

const seoUrl = ref();
const seoImage = ref();

const seoTitle = `Politique de Confidentialité - TopAuto`;
const seoDescription = `Découvrez comment TopAuto collecte, utilise et protège vos données personnelles lors de l’achat et la vente de voitures d’occasion en Tunisie. Infos sur cookies, sécurité et vos droits.`;
seoUrl.value = `${runTimeConfig.public.clientBaseUrl}${route.fullPath}`;
seoImage.value = `${runTimeConfig.public.clientBaseUrl}/_nuxt/assets/images/logos/Logo.png`;

useHead({
  title: seoTitle,
  link: [
    {
      rel: 'canonical',
      href: seoUrl
    }
  ],
  meta: [
    {
      name: 'description',
      content: seoDescription
    },
    {
      property: 'og:title',
      content: seoTitle
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:description',
      content: seoDescription
    },
    {
      property: 'og:url',
      content: seoUrl
    },
    {
      property: 'og:image',
      content: seoImage
    },
    {
      property: 'og:site_name',
      content: 'TopAuto'
    }
  ]
});

</script>

<style scoped>

</style>